const Container: FC = ({ children }) => (
  <div className="grid h-full w-full content-center items-center justify-center gap-3 overflow-hidden rounded-sm bg-black/60 opacity-0 transition-opacity hover:opacity-100 ">
    {children}
  </div>
);

export default Container;
